'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _es6Tween = require('es6-tween');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var propTypes = {
	class: {
		type: 'string'
	},
	duration: {
		type: 'number'
	},
	show: {
		type: 'number'
	},
	top: {
		type: 'number'
	}
};

var defaultProps = {
	duration: 500,
	top: 0
};

var scrollTo = function scrollTo(x, y) {
	var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	(0, _es6Tween.autoPlay)(true);

	new _es6Tween.Tween({
		x: window.pageXOffset || document.documentElement.scrollLeft,
		y: window.pageYOffset || document.documentElement.scrollTop
	}).to({ x: x, y: y }, options.duration).easing(_es6Tween.Easing.Cubic.InOut).on('update', function (obj) {
		return window.scrollTo(obj.x | 0, obj.y | 0);
	}).start();
};

var onClick = function onClick(_ref) {
	var duration = _ref.duration,
	    top = _ref.top;
	return function () {
		return scrollTo(0, top, { duration: duration });
	};
};

var afterMount = function afterMount(_ref2, el, setState) {
	var props = _ref2.props;
	var show = props.show;


	window.addEventListener('scroll', function () {
		if (window.scrollY >= show) {
			setState({ active: true });
			return;
		}

		setState({ active: false });
	});
};

var shouldUpdate = function shouldUpdate(_ref3, nextProps, _ref4) {
	var state = _ref3.state;
	var active = _ref4.active;
	return !state.active === active;
};

var render = function render(_ref5) {
	var props = _ref5.props,
	    state = _ref5.state;
	var children = props.children,
	    styleClasses = props.styleClasses;
	var active = state.active;


	return (0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['ScrollUp', { 'ScrollUpLegacyStyles': !styleClasses || styleClasses && !styleClasses.Scroll_To_Top }, styleClasses && styleClasses.Scroll_To_Top, props.class, { 'ScrollUp--active': active }], 'data-style-attr': 'Scroll_To_Top', onClick: onClick(props) },
		children
	);
};

exports.default = { afterMount: afterMount, defaultProps: defaultProps, propTypes: propTypes, render: render, shouldUpdate: shouldUpdate };
